import { Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { JobsService } from "../../jobs.service";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class JobTimeTrackingService {
  constructor(private http: HttpClient) {}

  startWithPreviousValue = new Subject();
  previousTrackingTimeTracked: number = 0;
  isTracking = new Subject();
  updateTotalTimeTracked = new Subject();

  startTimeTracking(form, jobUuid) {
    const url = environment.apiUrl;
    return this.http
      .post<any>(`${url}/jobs/start_timer/${jobUuid}`, form)
      .toPromise();
  }

  checkTimeTracking(jobUuid: string) {
    const url = `${environment.apiUrl}/jobs/checkTimeTracking/${jobUuid}`;
    return this.http.get(url);
  }

  stopTimer(jobUuid: string, time_tracked: Object) {
    const url = `${environment.apiUrl}/jobs/stopTimer/${jobUuid}`;
    return this.http.post(url, time_tracked).toPromise();
  }

  timeTrackingDetails(jobUuid: string) {
    const url = `${environment.apiUrl}/jobs/timeTrackingDetails/${jobUuid}`;
    return this.http.get(url).toPromise();
  }

  timeTrackedFormatter(totalSeconds: number): string {
    const seconds = Math.floor(totalSeconds);

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const hoursStr = hours < 10 ? "0" + hours : hours.toString();
    const minsStr = minutes < 10 ? "0" + minutes : minutes.toString();
    const secsStr = secs < 10 ? "0" + secs : secs.toString();

    return `${hoursStr}:${minsStr}:${secsStr}`;
  }

  checkPreviousEntry(jobUuid: string) {
    const url = `${environment.apiUrl}/jobs/checkPreviousEntry/${jobUuid}`;
    return this.http.get<any>(url).toPromise();
  }

  retrieveTimeTrackingEntries(
    personFilter = null,
    timeFrameFilter = null,
    sortBy = null,
    sortOrder = null,
    first = null,
    rows = null,
  ) {
    let params = `?rows=${rows}&start=${first}`;

    if (personFilter) {
      params += `&personFilter=${personFilter}`;
    }

    if (timeFrameFilter) {
      if (Array.isArray(timeFrameFilter)) {
        params += `&timeFrameFilter=custom_date&startDate=${timeFrameFilter[0]}&completedDate=${timeFrameFilter[1]}`;
      } else {
        params += `&timeFrameFilter=${timeFrameFilter}`;
      }
    }

    if (sortBy) {
      params += `&sortBy=${sortBy}`;
    }

    if (sortOrder) {
      params += `&sortOrder=${sortOrder}`;
    }

    const url = `${environment.apiUrl}/jobs/retrieveTimeTrackingEntries${params}`;

    return this.http.get(url).toPromise();
  }

  updateTimeTrackingTime(uuid, timeTracked) {
    const url = `${environment.apiUrl}/jobs/updateTimeTracking`;
    return this.http.patch(url, { uuid, timeTracked }).toPromise();
  }

  updateTimeTracking(timeTracking) {
    const url = `${environment.apiUrl}/jobs/updateTimeTracking`;
    return this.http.put(url, timeTracking).toPromise();
  }

  addNewEntryFromDetails(jobUuid, timeTracking) {
    const url = `${environment.apiUrl}/jobs/updateTimeTracking`;
    return this.http
      .post(url, { new_entry: timeTracking, job_uuid: jobUuid })
      .toPromise();
  }

  pauseResumeTimer(action) {
    const url = `${environment.apiUrl}/jobs/time-tracking-status`;
    return this.http
      .put<any>(url, { action }, { observe: "response" })
      .toPromise();
  }
}
